import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRefs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselPagination',
  props: {
    slideIndex: {},
    totalSlides: {},
    classes: {}
  },
  setup(__props: any) {

const props = __props;
const { slideIndex, totalSlides, classes } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(classes))
  }, _toDisplayString(_unref(slideIndex) < 1 ? _unref(totalSlides) : _unref(slideIndex) <= _unref(totalSlides) ? _unref(slideIndex) : 1) + " of " + _toDisplayString(_unref(totalSlides)), 3))
}
}

})